import React from 'react';
import '../../src/bootstrap.css';



const Feedback = () => {
 return (
  <>
  <div className="bobo my-5 py-5">
  
   <h3 className="text-dark text-center my-1">Thanks for your Feedback!!! 
   </h3>
   <h3 className="text-center my-1">We will get back to you shortly.</h3>
  </div>
   {/* <HeroSection /> */}
   {/* <Cards /> */}
   {/* <Footer /> */}
   
  </>
 )
}

export default Feedback